let ROOT
switch (import.meta.env.MODE) {
  case "production":
    ROOT = "https://lb-new.pt.arnvind.com"
    break
  case "test":
    ROOT = "https://lb.testpt.arnvind.com"
    break
  default:
    ROOT = "http://localhost:5000"
    break
}

export default ROOT
